(() => {
  if (window.bnonInstrumentAmpersandLoaded) return;
  window.bnonInstrumentAmpersandLoaded = true;

  const root = document.querySelector('#MainContent');
  if (!root) return;


  const excluded = 'script, style, svg, code, pre, textarea, .bnon-instrument-ampersand, [data-bnon-ampersand-exclude]';
  const decorate = (node) => {
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      const text = walker.currentNode;
      if (text.nodeValue.includes('&') && !text.parentElement.closest(excluded)) textNodes.push(text);
    }
    textNodes.forEach(text => {
      const fragment = document.createDocumentFragment();
      text.nodeValue.split('&').forEach((part, index) => {
        if (index) {
          const ampersand = document.createElement('span');
          ampersand.className = 'bnon-instrument-ampersand';
          ampersand.textContent = '&';
          fragment.append(ampersand);
        }
        if (part) fragment.append(document.createTextNode(part));
      });
      text.replaceWith(fragment);
    });
  };

  decorate(root);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') decorate(record.target.parentElement);
      record.addedNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) decorate(node.parentElement);
        else if (node.nodeType === Node.ELEMENT_NODE) decorate(node);
      });
    });
  }).observe(root, { childList: true, characterData: true, subtree: true });
})();
